import loading from '../helpers/loading'
import collectionPerPage from '../helpers/collectionPerPage'

import actions from './actions'

export default {
  namespaced: true,
  state: {
    ...loading.state,
    ...collectionPerPage.state
  },
  mutations: {
    ...loading.mutations,
    ...collectionPerPage.mutations
  },
  getters: {
    ...loading.getters,
    ...collectionPerPage.getters,
    pending: (state, getters, rootState, rootGetters) => rootGetters['skiliko/session/currentUser']
      ? Object.keys(getters.collection)
        .map(id => getters.collection[id])
        .filter(message => message.to.scope === 'admin')
        .filter(message => message.to._id === rootGetters['skiliko/session/currentUser'].chatable_id)
        .filter(message => !message.readAt)
      : []
  },
  actions
}



// WEBPACK FOOTER //
// ./src/store/skiliko/messages/index.js